import { Typography } from '../primitives/index.js'
import type { FC } from 'react'
import { graphHooks } from '@tunasong/graph-lib/react'
import { UserAvatar } from './user-avatar.js'
import styles from './profile-card.module.css'

export interface ProfileCardProps {
  userId: string
}

export const ProfileCard: FC<ProfileCardProps> = props => {
  const { userId } = props
  const { profile: user } = graphHooks.useProfile(userId)
  /** Other users' profiles carry no email, so the subheader only shows on your own card */
  const title = user?.name ?? user?.email ?? 'Unnamed user'
  const subheader = user?.name ? user?.email : ''
  return (
    <div className={styles.container}>
      <UserAvatar userId={userId} className={styles.avatar} />
      <div>
        <Typography variant="subtitle1">{title}</Typography>
        {subheader ? (
          <Typography variant="body2" color="textSecondary">
            {subheader}
          </Typography>
        ) : null}
      </div>
    </div>
  )
}
export default ProfileCard
